'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwarePhoneAndroid = function HardwarePhoneAndroid(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z' })
  );
};
HardwarePhoneAndroid = (0, _pure2.default)(HardwarePhoneAndroid);
HardwarePhoneAndroid.displayName = 'HardwarePhoneAndroid';
HardwarePhoneAndroid.muiName = 'SvgIcon';

exports.default = HardwarePhoneAndroid;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/hardware/phone-android.js
// module id = 3035
// module chunks = 0